<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>
            
                            <div class="modal-header" style="justify-content: flex-end;">
                                <button type="button" class="close" @click="$emit('closeModal')">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
            
                            <div class="modal-body">
                                <h2 class="title" style="margin-bottom: 20px;">Detail Opname</h2>


                                <!-- {{detailList}} -->
                                <vue-universal-table 
                                    :data="detailList"
                                    :table_striped="false"
                                    :fields="fields"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                </div>
            </div>
        </div>
    </transition>
</template>
    
<script>
export default {
    props : ['detailList'],
    data () {
        return {
            fields : [{
                title : 'Qrcode',
                variable : 'qrcode'
            }, {
                title : 'Engine Number',
                variable : 'engine_no',
            } , {
                title : 'Lattitude',
                variable : 'lat',
            }, {
                title : 'Longitude',
                variable : 'engine_no',
            }]
            /*
                Qrcode
                :
                Swg4TQwc2rDmWaALhcfprpmHuJkOZiHu
                Engine No
                :
                JFZ1E3108462
                Lat
                :
                -6.14292183
                Lng
                :
                106.85673778
            */
        }
    }
}
</script>>
    
  <style scoped>
  
  
    /* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
    input {
      outline: none;
      margin: 0;
      border: none;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
      width: 100%;
      font-size: 14px;
      font-family: inherit;
    }
    
    .input--style-4 {
      line-height: 50px;
      background: #fafafa;
      -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
      -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
      box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      padding: 0 20px;
      font-size: 16px;
      color: #666;
      -webkit-transition: all 0.4s ease;
      -o-transition: all 0.4s ease;
      -moz-transition: all 0.4s ease;
      transition: all 0.4s ease;
    }
    
    .input--style-4::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #666;
    }
    
    .input--style-4:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #666;
      opacity: 1;
    }
    
    .input--style-4::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #666;
      opacity: 1;
    }
    
    .input--style-4:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #666;
    }
    
    .input--style-4:-ms-input-placeholder {
      /* Microsoft Edge */
      color: #666;
    }
    
    .label {
      font-size: 16px;
      color: #555;
      text-transform: capitalize;
      display: block;
      margin-bottom: 5px;
    }
    
    .radio-container {
      display: inline-block;
      position: relative;
      padding-left: 30px;
      cursor: pointer;
      font-size: 16px;
      color: #666;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    
    .radio-container input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
    
    .radio-container input:checked ~ .checkmark {
      background-color: #e5e5e5;
    }
    
    .radio-container input:checked ~ .checkmark:after {
      display: block;
    }
    
    .radio-container .checkmark:after {
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      width: 12px;
      height: 12px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      background: #57b846;
    }
    
    .checkmark {
      position: absolute;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -o-transform: translateY(-50%);
      transform: translateY(-50%);
      left: 0;
      height: 20px;
      width: 20px;
      background-color: #e5e5e5;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
      -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
      box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    }
    
    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }
    
    .input-group {
      position: relative;
      /* margin-bottom: 22px; */
      padding:20px;
    }
    
    .input-group-icon {
      position: relative;
    }
    
    .input-icon {
      position: absolute;
      font-size: 18px;
      color: #999;
      right: 18px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -o-transform: translateY(-50%);
      transform: translateY(-50%);
      cursor: pointer;
    }
    
    /* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
    .title {
      font-size: 16px;
      color: #5D5D5D;
      margin-bottom: 40px;
      text-align: center;
    }
  
    .modal-body{
      max-height: 80vh;
      overflow-y:auto;
      overflow-x:auto;
    }
    .innerBox{
      padding: 1.5rem 1.5rem 1.5rem 2.25rem;
      border: 1px solid #EEEEEE;
      border-radius: 5px;
      background-color: white;
      box-shadow: 2px 2px 5px #E0E0E0;
    }
    .custom-control{
      margin-bottom: 0;
    }
  
    .hoverable:hover{
      cursor: pointer;
    }
  </style>
    